var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterSettings = function SvgFilterSettings(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    viewBox: "0 0 19.5 18.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.738 10.21a3.13 3.13 0 0 0-.528 1.74 3.12 3.12 0 0 0 2.37 3.039v2.761a.75.75 0 1 0 1.5 0v-2.759a3.13 3.13 0 0 0 0-6.082V.75a.75.75 0 1 0-1.5 0v8.164a3.13 3.13 0 0 0-1.842 1.296m2.491.113a1.63 1.63 0 0 0 .101 3.257 1.62 1.62 0 0 0 1.63-1.63 1.63 1.63 0 0 0-1.529-1.627.7.7 0 0 1-.202 0M7.128 4.761A3.13 3.13 0 0 0 8.98 9.54v8.211a.75.75 0 1 0 1.5 0V9.539a3.13 3.13 0 0 0 0-6.078V.75a.75.75 0 1 0-1.5 0v2.711a3.13 3.13 0 0 0-1.852 1.3m3.704.67a1.63 1.63 0 1 1-2.213 2.393 1.63 1.63 0 0 1 2.213-2.393M.528 10.21A3.13 3.13 0 0 0 2.38 14.99v2.761a.75.75 0 1 0 1.5 0v-2.761a3.13 3.13 0 0 0 2.32-3.65 3.13 3.13 0 0 0-2.32-2.428V.75a.75.75 0 1 0-1.5 0v8.161a3.13 3.13 0 0 0-1.852 1.3m3.704.67a1.63 1.63 0 1 1-2.213 2.393 1.63 1.63 0 0 1 2.213-2.393",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterSettings);
export default ForwardRef;